import React from "react";
import icSearch from "@/assets/icons/icon-search2.svg";
import icClose from "@/assets/icons/ic-close.svg";
import { cn } from "@/lib/utils";

export interface SearchInputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  containerClassName?: string;
  onClear?: () => void;
}

export const SearchInput = React.forwardRef<HTMLInputElement, SearchInputProps>(
  ({ className, containerClassName, onClear, value, ...props }, ref) => {
    return (
      <div className={cn("relative w-[400px]", containerClassName)}>
        <img
          src={icSearch}
          alt="Search"
          className="absolute left-4 top-1/2 -translate-y-1/2 w-6 h-6 pointer-events-none"
        />
        <input
          ref={ref}
          type="text"
          value={value}
          className={cn(
            "w-full h-[48px] pl-12 rounded-[4px] bg-white border border-[#00000027] text-base text-[#000000E8] placeholder:text-[#B0B0B0] focus:outline-none transition-colors",
            onClear && value ? "pr-10" : "pr-4",
            className
          )}
          {...props}
        />
        {onClear && value && String(value).length > 0 && (
          <button
            type="button"
            onClick={onClear}
            className="absolute right-3 top-1/2 -translate-y-1/2 w-5 h-5 flex items-center justify-center text-[#8D8D8D] hover:text-[#202020]"
          >
            <img src={icClose} alt="Clear" className="w-4 h-4" />
          </button>
        )}
      </div>
    );
  }
);

SearchInput.displayName = "SearchInput";
